module.exports = __webpack_public_path__ + "static/media/retest.6640247a.svg";